import { VoyMapModelBase } from "./voy-map-model";
import { Map as MGMap } from '@meteogroup/map-layers';
export class VoyMapModelImpl extends VoyMapModelBase {
    private _map: MGMap|null = null;

    setZoomLevel(zoom: number): void {
      this._map?.getView().animate({zoom});
    }

    assignMap(map: MGMap) {
        this._map = map;
    }
}
